import { useState } from "react";
import { openConsentSettings } from "../lib/consent";
import { Link } from "react-router-dom";
import NewsletterPopup from "./NewsletterPopup";

const LOGO_URL = "/images/optimized/logo-wordmark-v3.webp";

export default function Footer() {
  const [showNewsletterPopup, setShowNewsletterPopup] = useState(false);

  return (
    <footer data-testid="footer">
      {/* Newsletter Section - Now triggers popup */}
      <div className="bg-[#0f1d2f] py-16 lg:py-20 px-6">
        <div className="max-w-xl mx-auto text-center">
          <h3 className="text-xl text-white mb-6" style={{ fontFamily: "'GFS Didot', 'Didot', serif" }}>
            Stay Connected
          </h3>
          <p className="text-sm text-white/70 leading-relaxed mb-8" data-testid="stay-connected-text">
            Discover what's growing across America.<br />
            Receive curated updates on independent farms, seasonal offerings, regional events, and new opportunities to discover and shop directly from producers.
          </p>
          <button
            onClick={() => setShowNewsletterPopup(true)}
            className="px-10 py-4 text-xs tracking-widest uppercase transition-all hover:opacity-90"
            style={{ 
              backgroundColor: '#ffffff', 
              color: '#0f1d2f',
              border: 'none'
            }}
            data-testid="newsletter-trigger-btn"
          >
            Receive Updates
          </button>
        </div>
      </div>

      {/* Newsletter Popup */}
      <NewsletterPopup 
        isOpen={showNewsletterPopup} 
        onClose={() => setShowNewsletterPopup(false)}
        source="footer"
      />

      {/* Main Footer */}
      <div className="bg-white border-t" style={{ borderColor: 'rgba(30, 58, 95, 0.1)' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
          <div className="flex flex-col items-center text-center">
            {/* Logo */}
            <img 
              src={LOGO_URL} loading="lazy" decoding="async"
              alt="American Farmstand" 
              className="h-14 w-auto mb-10"
            />
            
            {/* Links - Gold color */}
            <nav className="flex flex-wrap justify-center gap-8 lg:gap-12 mb-10">
              <Link 
                to="/our-marketplace" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                Our Marketplace
              </Link>
              <Link 
                to="/for-farms" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                For Farms
              </Link>
              <Link 
                to="/for-customers" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                For Members
              </Link>
              <Link
                to="/about"
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
                data-testid="footer-about-link"
              >
                About
              </Link>
              <Link
                to="/faq"
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
                data-testid="footer-faq-link"
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                Contact
              </Link>
            </nav>

            {/* Legal Links - Gold color */}
            <nav className="flex flex-wrap justify-center gap-6 mb-10">
              <button
                type="button"
                onClick={openConsentSettings}
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
                data-testid="footer-cookie-preferences"
              >
                Cookie Preferences
              </button>
              <Link 
                to="/privacy" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                Privacy
              </Link>
              <Link 
                to="/terms" 
                className="text-xs tracking-widest uppercase hover:opacity-70 transition-opacity"
                style={{ color: '#B6A46D' }}
              >
                Terms
              </Link>
            </nav>

            {/* Tagline */}
            <p 
              className="text-base italic mb-10 max-w-sm leading-relaxed"
              style={{ color: '#0f1d2f' }}
            >
              Supporting independent American farms.
            </p>

            {/* Copyright - Gold color */}
            <p 
              className="text-xs tracking-widest uppercase"
              style={{ color: '#B6A46D' }}
            >
              © {new Date().getFullYear()} American Farmstand
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
